import { useEffect, useCallback } from 'react';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

export const useSplashScreen = () => {
  const isNative = Capacitor.isNativePlatform();

  const hide = useCallback(async () => {
    if (isNative) {
      try {
        await SplashScreen.hide({
          fadeOutDuration: 500,
        });
      } catch (error) {
        console.log('SplashScreen hide error:', error);
      }
    }
  }, [isNative]);

  const show = useCallback(async () => {
    if (isNative) {
      try {
        await SplashScreen.show({
          showDuration: 2000,
          autoHide: true,
          fadeInDuration: 300,
          fadeOutDuration: 500,
        });
      } catch (error) {
        console.log('SplashScreen show error:', error);
      }
    }
  }, [isNative]);

  // Auto-hide splash screen when app is ready
  useEffect(() => {
    // Give the app a moment to render before hiding native splash
    const timer = setTimeout(() => {
      hide();
    }, 500);

    return () => clearTimeout(timer);
  }, [hide]);

  return {
    isNative,
    hide,
    show,
  };
};

export default useSplashScreen;
